import * as React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import useStyles from "./Button.styles";
import { FontAwesomeIcon } from "../../shared/FontAwesome";

interface Props {
    active?: boolean;
    text?: string;
    layout?: "vertical" | "horizontal";
    icon?: () => any | IconProp;
}

export default function Button({
    active,
    text,
    icon,
    layout,
    ...otherProps
}: Props & React.HTMLAttributes<HTMLDivElement>) {
    const [hover, setHover] = React.useState(false);
    const classes = useStyles({ active, hover, layout });

    return (
        <div
            className={classes.button}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            {...otherProps}
        >
            {icon && (
                <div className={classes.buttonIcon}>
                    {typeof icon === "function" ? icon() : <FontAwesomeIcon icon={icon} />}
                </div>
            )}
            {text}
        </div>
    );
}
